import { withTranslation } from './with-translation';
import { withExperiments } from './with-experiments';
import { withPermissions } from './with-market-permissions';
import { withMarketplaceStore } from './with-marketplace-store';
import { WithBi } from '../bi';
import { withSuspenseFetcherHOC } from './with-suspense-fetcher';
import { withUserDetails } from './with-user-details';
var Composer = /** @class */ (function () {
    function Composer() {
        this.funcs = [];
    }
    Composer.prototype.withTranslation = function () {
        this.funcs.push(withTranslation);
        return this;
    };
    Composer.prototype.withExperiments = function () {
        this.funcs.push(withExperiments);
        return this;
    };
    Composer.prototype.withPermissions = function () {
        this.funcs.push(withPermissions);
        return this;
    };
    Composer.prototype.withMarketplaceStore = function () {
        this.funcs.push(withMarketplaceStore);
        return this;
    };
    Composer.prototype.withBiLogger = function () {
        this.funcs.push(WithBi);
        return this;
    };
    Composer.prototype.withUserDetails = function () {
        this.funcs.push(withUserDetails);
        return this;
    };
    Composer.prototype.withSuspenseFetcher = function (fetchBuilder) {
        this.funcs.push(function (component) {
            return withSuspenseFetcherHOC(fetchBuilder, component);
        });
        return this;
    };
    Composer.prototype.compose = function (val) {
        return this.funcs.reduceRight(function (prevComposition, func) { var _a; return (_a = func === null || func === void 0 ? void 0 : func(prevComposition)) !== null && _a !== void 0 ? _a : prevComposition; }, val);
    };
    return Composer;
}());
export var composer = function () { return new Composer(); };
//# sourceMappingURL=composer.js.map